import { Statement } from './Statement';
export function isDiscourseStatement(discourse) {
    return discourse !== null && typeof discourse === 'object' && discourse instanceof Statement;
}
export {
    isDiscourseStatement as isStatement
};
export default isDiscourseStatement;    //# sourceMappingURL=isStatement.js.map
